import {ActiveTopBar} from '../Widget';

export function MinimalHeader() {
  return <ActiveTopBar />;
}
